import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { PipesModule } from '../pipes/pipes.module';
import { JoyrideModule } from 'ngx-joyride';



@NgModule({
  declarations: [

    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent,
  ],

  exports: [

    BreadcrumbsComponent,
    SidebarComponent,
    HeaderComponent,
    

  ],
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    JoyrideModule.forRoot(), 
  ]
})
export class SharedModule { }
